import { candidatesStore } from '../../reducers/Candidate/candidate.reducer';

export const selectAllCandidates = (state) => state.candidate[candidatesStore];
